import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import LineItems from "../../admin/Orders/OrderLineItem/LineItems";
import SubTotals from "../../admin/Orders/OrderLineItem/SubTotals";
import { useOrderService } from "../../../hooks";
import { Currency } from "../../../constant/Currency";
import { Order } from "../../../types/Order/Order";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

interface OrderDetailsModalProps {
  orderId: string;
  onClose: () => void;
}

const OrderDetailsModal = ({ orderId, onClose }: OrderDetailsModalProps) => {
  const navigate = useNavigate();
  const orderService = useOrderService();
  const [order, setOrder] = useState<Order | undefined>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orderId) return;
    const abortController = new AbortController();
    setLoading(true);
    orderService
      .GetOrderById(orderId, abortController)
      .then((order) => {
        setOrder(order);
        setLoading(false);
      })
      .catch(() => {});

    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const onDownloadClick = (id: string) => {
    if (order == null) return;
    const url = `/download/data/${order.id}/${id}`;
    navigate(url);
  };

  return (
    <ThemedModal onHide={onClose} centered scrollable show={true}>
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Order Details</StyledModalTitle>
      </Modal.Header>
      <Modal.Body className="overflow-auto">
        {loading && (
          <div className="d-flex justify-content-center">
            <Spinner />
          </div>
        )}
        {order && (
          <>
            <Row className="mb-0 g-0">
              <Col md="2">Name: </Col>
              <Col>
                {order.user.firstName} {order.user.lastName}
              </Col>
            </Row>
            <Row className="mb-3 g-0">
              <Col md="2">Created: </Col>
              <Col>{order.createdDate.toFormat("dd/MM/yyyy HH:mm")}</Col>
            </Row>
            <p className="mb-0">Ordered Items</p>
            <LineItems
              currency={Currency.GBP}
              items={order.lineItems ?? []}
              inclTax={false}
              onDownload={onDownloadClick}
            />
            <SubTotals
              transactionCurrencyCode={order.transactionCurrencyCode}
              totalExTax={order.totalExTax}
              totalTax={order.totalTax}
              totalIncTax={order.totalIncTax}
            />
          </>
        )}
      </Modal.Body>
    </ThemedModal>
  );
};

export default OrderDetailsModal;
